const analytics = require('svtlib-statistics');
const error = require('debug')('svtse:tracker:error');
const { contextMetricsSelector, autoCompleteSelector } = require('../selectors');
const {
	CLIENT_INITIALIZE,
	RESOURCE_DISPLAY,
	AUTO_COMPLETE_UPDATE_QUERY
} = require('../actions');

const orvesto = (() => {
	if(typeof window === 'undefined') { return () => {}; }
	const orvestoLib = typeof window !== 'undefined'? require('orvesto-lib') : [];
	return {
		trackAsPageView: (contextMetrics) => {
			if (document.cookie.match("__codnt") === null) {
				const trackingPath = '/' + contextMetrics.svt_level1 + '/' + contextMetrics.svt_level2 + '/' + contextMetrics.svt_level3;
				orvestoLib.push(
					{cmd: "_trackContentPath", val: trackingPath},
					{cmd: "_executeTracking"}
				);
			}
		}
	};
})();

const trackAsPageView = (contextMetrics) => {
	analytics.trackAsPageView(contextMetrics);
	orvesto.trackAsPageView(contextMetrics);
	return;
};

const trackAsSearchQuery = (() => {
	var timeoutID = -1;
	return (contextMetrics, query, noHits) => {
		clearTimeout(timeoutID);
		if(query !== '') {
			timeoutID = setTimeout(() => {
			analytics.trackAsEvent('search-result', Object.assign({}, contextMetrics, {
					'linkTrackEvents': 'event1',
					'eVar1': query,
					'prop1': query,
					'prop9': 'svt.se',
					'prop12': noHits.toString(),
					'events': 'event1'
			}));
			}, 500);
		}
	};
})();

const tracker = (store) => (next) => (action) => {
  const result = next(action);
	const data = contextMetricsSelector(store.getState()).toJS();
	switch (action.type) {
		case AUTO_COMPLETE_UPDATE_QUERY:
			const autoComplete = autoCompleteSelector(store.getState());
			trackAsSearchQuery(data, autoComplete.get('searchTerm', ''), autoComplete.get('count', 0));
			return result;
		case CLIENT_INITIALIZE:
		case RESOURCE_DISPLAY:
			if(typeof window !== 'undefined') {
				analytics.linkInternalFilters = analytics.linkInternalFilters + ',localhost' + ',' + window.location.hostname;
				if(Object.keys(data).length === 0) { error('unable to create statistics object for %o', store.getState()); }
				trackAsPageView(data);
			}
		return result;
	}
  return result;
};

export default tracker;



/** WEBPACK FOOTER **
 ** ./app/middleware/tracker.js
 **/